import { ReactNode } from "react";
import styled from "styled-components";

interface CenteredContainerProps {
  children: ReactNode;
}

export const CenteredContainer = ({ children }: CenteredContainerProps) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
